<template>
    <div class="animated fadeIn">
        <div class="card-header">
            <div class="row align-items-center justify-content-between">
                <div class="col-md-6">
                    <div class="search-select-wrapper">
                        <select class="custom-select-filter" v-model="filtroTipo">
                            <option value="">Todos os tipos</option>
                            <option v-for="tipo in tipoTicket" :key="tipo.id" :value="tipo.id">
                                {{ tipo.desc }}
                            </option>
                        </select>
                        <fa-icon icon="search" class="search-icon" />
                    </div>
                </div>

                <div class="col-md-6 text-right">
                    <button type="button" class="button button-success button-sm"
                        v-on:click="openCreate('tipoTicketEdit')" v-if="perms['SAC_TIPO_TICKET']">
                        <fa-icon icon="plus" /> Adicionar Tipo de Ticket
                    </button>
                </div>
            </div>
        </div>

        <Loading :isActive="loading" />

        <div>
            <div class="row">
                <div class="col-12" v-if="tipoTicketFiltrados && tipoTicketFiltrados.length > 0">
                    <div v-for="tipo in tipoTicketFiltrados" :key="tipo.id" class="card mb-4">
                        <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center flex-wrap">
                                <div class="d-flex align-items-center">
                                    <h5 class="card-title mb-0 mr-3">
                                        <fa-icon icon="tag" class="mr-2" /> {{ tipo.desc }}
                                    </h5>
                                    <span class="badge badge-primary badge-pill">
                                        {{ getTicketsByTipo(tipo.id).length }} itens
                                    </span>
                                    <span class="label primary ml-2">
                                        {{ tipo.menu }}
                                    </span>


                                </div>

                                <div class="action-buttons d-flex flex-wrap">
                                    <button type="button" class="button button-success button-sm mr-2"
                                        v-on:click="onEtapaCreate(tipo)" v-if="perms['SAC_TIPO_TICKET_ETAPA']">
                                        <fa-icon icon="plus" /> Adicionar Etapa
                                    </button>
                                    <button type="button" class="button button-primary button-sm mr-2"
                                        v-on:click="openEdit(tipo, 'tipoTicketEdit')" v-if="perms['SAC_TIPO_TICKET']">
                                        <fa-icon icon="pencil-alt" />
                                    </button>
                                    <button type="button" class="button button-error button-sm"
                                        v-on:click="deleteConfirmTipoTicket(tipo.id)" v-if="perms['SAC_TIPO_TICKET']">
                                        <fa-icon icon="trash-alt" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="card-body">
                            <draggable :list="tipoTicketEtapaPorTipo[tipo.id]" group="tickets" class="board-container"
                                :sort="true" :animation="200" ghost-class="card-ghost" chosen-class="card-chosen"
                                drag-class="card-drag" @end="onDragEnd(tipo.id)" @change="onDragChange($event, tipo.id)"
                                @moved="onDragMoved($event, tipo.id)" @removed="onDragRemoved($event, tipo.id)">
                                <div v-for="(ticket, index) in getTicketsByTipo(tipo.id)" :key="ticket.id"
                                    class="card ticket-card">
                                    <div class="card-header">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <small class="text-muted">#{{ ticket.id }}</small>
                                            <div class="d-flex align-items-center ticket-action-buttons">
                                                <span class="badge badge-primary">{{ index + 1 }}</span>
                                                <button type="button" class="button button-primary button-sm"
                                                    v-on:click="openEdit(ticket, 'tipoTicketEtapaEdit')" v-if="perms['SAC_TIPO_TICKET_ETAPA']">
                                                    <fa-icon icon="pencil-alt" />
                                                </button>
                                                <button type="button" class="button button-error button-sm"
                                                    v-on:click="onEtapaDelete(ticket, tipo.id)" v-if="perms['SAC_TIPO_TICKET_ETAPA']">
                                                    <fa-icon icon="trash-alt" />
                                                </button>
                                                <button type="button" class="button button-info button-sm"
                                                    @click="cloneEtapa(ticket, tipo.id)" v-if="perms['SAC_TIPO_TICKET_ETAPA']">
                                                    <fa-icon icon="copy" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-body">
                                        <h6 class="card-title">{{ ticket.desc }}</h6>
                                        <p class="card-text small text-muted">{{ ticket.chave }}</p>

                                        <div class="mb-2">
                                            <span class="badge badge-light mr-1">
                                                <fa-icon icon="clock" class="mr-1" /> SLA: {{ ticket.sla_maximo ??
                                                'Indefinido' }}
                                            </span>
                                            <span class="badge badge-light">
                                                <fa-icon icon="building" class="mr-1" /> {{
                                                getSetorName(ticket.setor_id) }}
                                            </span>
                                        </div>

                                        <div v-if="ticket.permite_finalizar || ticket.permite_retroceder || ticket.permite_avancar"
                                            class="mb-2">
                                            <span v-if="ticket.permite_finalizar == 1" class="badge badge-success mr-1">
                                                <fa-icon icon="check-circle" class="mr-1" /> Finalizar
                                            </span>
                                            <span v-if="ticket.permite_retroceder == 1"
                                                class="badge badge-warning mr-1">
                                                <fa-icon icon="chevron-left" class="mr-1" /> Retroceder
                                            </span>
                                            <span v-if="ticket.permite_avancar == 1" class="badge badge-info">
                                                <fa-icon icon="chevron-right" class="mr-1" /> Avançar
                                            </span>
                                        </div>
                                    </div>

                                    <div class="card-footer text-center bg-light">
                                        <small class="text-muted d-flex align-items-center justify-content-center">
                                            <fa-icon icon="grip-vertical" class="mr-2" />
                                            ARRASTAR
                                        </small>
                                    </div>
                                </div>
                            </draggable>
                            <div v-if="getTicketsByTipo(tipo.id).length === 0" class="empty-state">
                                <div class="text-center p-4">
                                    <fa-icon icon="inbox" class="text-muted mb-2" style="font-size: 3rem;" />
                                    <p class="text-muted mb-0">Nenhuma etapa para este tipo de ticket</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="col-12">
                    <div class="card" v-if="!loading">
                        <div class="card-body text-center p-5">
                            <fa-icon icon="exclamation-triangle" class="text-warning mb-3" style="font-size: 4rem;" />
                            <h5>Nenhum tipo de ticket disponível</h5>
                            <p class="text-muted">Configure os tipos de ticket primeiro</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import draggable from 'vuedraggable'
import { loadAuthorizationAction } from "@/helpers/cargas"
import { get, put, post } from '@/helpers/apiRequest'

export default {
    name: 'TipoTicketEtapaBoard',
    components: { draggable },
    props: [
        'tipoTicket',
        'setores',
        'openEdit',
        'openCreate',
        'deleteConfirmTipoTicket',
        'deleteConfirmTipoTicketEtapa'
    ],
    data() {
        return {
            loading: false,
            saving: false,
            filtroTipo: '',
            tipoTicketEtapa: [],
            tipoTicketEtapaPorTipo: {},
            editingItem: {},
            errors: {},
            perms: {}
        }
    },
    computed: {
        tipoTicketFiltrados() {
            if (!this.filtroTipo) return this.tipoTicket
            return this.tipoTicket.filter(tipo => tipo.id == this.filtroTipo)
        }
    },
    mounted() {
        this.loadData()
        this.perms = {
            'SAC_TIPO_TICKET_ETAPA': loadAuthorizationAction('ADMIN_SAC', 'SAC_TIPO_TICKET_ETAPA'),
            'SAC_TIPO_TICKET': loadAuthorizationAction('ADMIN_SAC', 'SAC_TIPO_TICKET')    
        }
    },
    methods: {
        async loadData() {
            this.loading = true
            try {
                const response = await get('/admin/sac/tipo-ticket-etapa')
                this.tipoTicketEtapa = response

                this.tipoTicketEtapaPorTipo = {}
                this.tipoTicket.forEach(tipo => {
                    const ticketsOrdenados = response
                        .filter(item => item.tipo_ticket_id === tipo.id)
                        .sort((a, b) => a.ordem - b.ordem)
                    this.$set(this.tipoTicketEtapaPorTipo, tipo.id, ticketsOrdenados)
                })
            } catch (error) {
                console.error('Erro ao carregar dados:', error)
            } finally {
                this.loading = false
            }
        },

        getTicketsByTipo(tipoId) {
            return this.tipoTicketEtapaPorTipo[tipoId] || []
        },

        getSetorName(setorId) {
            const setor = this.setores.find(s => s.id === setorId)
            return setor ? setor.desc : 'Setor: Indefinido'
        },

        onDragChange(event, tipoId) {
            if (event.added) {
                const addedTicket = event.added.element
                addedTicket.tipo_ticket_id = tipoId
                this.saveEtapaChanges(addedTicket)
                this.updateOrders(tipoId)
            }
        },

        onDragEnd(tipoId) {
            const tickets = this.tipoTicketEtapaPorTipo[tipoId]
            tickets.forEach((ticket, index) => {
                const novaOrdem = index + 1
                if (ticket.ordem !== novaOrdem) {
                    ticket.ordem = novaOrdem
                    this.saveEtapaChanges(ticket)
                }
            })
        },

        onDragMoved(event, tipoId) {
            this.updateOrders(tipoId)
        },

        onDragRemoved(event, tipoId) {
            this.updateOrders(tipoId)
        },

        updateOrders(tipoId) {
            const tickets = this.getTicketsByTipo(tipoId)
            tickets.forEach((ticket, index) => {
                const novaOrdem = index + 1
                if (ticket.ordem !== novaOrdem) {
                    ticket.ordem = novaOrdem
                    this.saveEtapaChanges(ticket)
                }
            })
        },

        async saveEtapaChanges(ticket) {
            try {
                const payload = {
                    id: ticket.id,
                    tipo_ticket_id: ticket.tipo_ticket_id,
                    chave: ticket.chave,
                    desc: ticket.desc,
                    permite_finalizar: ticket.permite_finalizar,
                    permite_retroceder: ticket.permite_retroceder,
                    permite_avancar: ticket.permite_avancar,
                    sla_maximo: ticket.sla_maximo,
                    setor_id: ticket.setor_id,
                    ordem: ticket.ordem,
                    permite_custos: ticket.permite_custos,
                    aguarda_cliente: ticket.aguarda_cliente,
                    final: ticket.final,
                    usa_motivo: ticket.usa_motivo,
                    permite_alterar_itens: ticket.permite_alterar_itens,
                }
                await put(`/admin/sac/tipo-ticket-etapa/${ticket.id}`, payload)
            } catch (error) {
                console.error('Erro ao salvar ticket:', error)
            }
        },

        async onEtapaDelete(ticket, tipoId) {
            const confirmado = await this.deleteConfirmTipoTicketEtapa(ticket.id)
            if (!confirmado) return

            const ordemDeletado = ticket.ordem
            const listaTickets = this.tipoTicketEtapaPorTipo[tipoId] || []
            const sucessores = listaTickets.filter(t => t.ordem > ordemDeletado)

            for (const t of sucessores) {
                t.ordem = t.ordem - 1
                await this.saveEtapaChanges(t)
            }

            await this.loadData()
        },

        onEtapaCreate(tipo) {
            const ordem = (this.tipoTicketEtapaPorTipo[tipo.id] || []).length + 1
            this.openCreate('tipoTicketEtapaEdit', {
                etapaTipoTicketId: tipo.id,
                etapaTicketOrdem: ordem
            })
        },

        async cloneEtapa(ticketOriginal, tipoId) {
            const listaOriginal = this.tipoTicketEtapaPorTipo[tipoId] || []
            const indexOriginal = listaOriginal.findIndex(t => t.id === ticketOriginal.id)

            if (indexOriginal === -1) {
                console.error('Ticket original não encontrado na lista')
                return
            }

            const ticketClonado = {
                ...ticketOriginal,
                id: undefined,
                ordem: ticketOriginal.ordem + 1,
                chave: ticketOriginal.chave + '_CLONE',
                desc: ticketOriginal.desc + ' (clonado)',
            }

            try {
                await post('/admin/sac/tipo-ticket-etapa', ticketClonado)

                const listaTickets = this.tipoTicketEtapaPorTipo[tipoId] || []
                const sucessores = listaTickets.filter(t => t.ordem > ticketOriginal.ordem)

                for (const t of sucessores) {
                    t.ordem = t.ordem + 1
                    await this.saveEtapaChanges(t)
                }

                this.$swal({
                    title: 'Clonado com sucesso!',
                    text: `O ticket "${ticketOriginal.chave}" foi clonado.`,
                    icon: 'success',
                    showConfirmButton: true,
                })
                await this.loadData()
            } catch (error) {
                console.error('Erro ao clonar ticket:', error)
                this.$swal({
                    title: 'Erro ao clonar',
                    text: 'Ocorreu um problema ao tentar clonar o ticket.',
                    icon: 'error',
                })
            }
        }
    }
}
</script>

<style scoped>
.board-container {
    display: flex;
    gap: 1rem;
    min-height: 200px;
    padding: 1rem;
    background-color: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 0.375rem;
    overflow-x: auto;
}

.ticket-card {
    width: 280px;
    min-width: 280px;
    cursor: move;
    transition: all 0.2s ease;
}

.ticket-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-ghost {
    opacity: 0.5;
    background: #f8f9fa;
    border: 2px dashed #007bff;
}

.card-chosen {
    transform: rotate(2deg);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-drag {
    transform: rotate(2deg);
    opacity: 0.8;
}

.empty-state {
    border: 2px dashed #dee2e6;
    border-radius: 0.375rem;
    background-color: #f8f9fa;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-header .action-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.card-header h5 {
    display: flex;
    align-items: center;
    margin: 0;
}

.card-header .badge {
    margin-left: 0.5rem;
}

.search-select-wrapper {
    position: relative;
    width: 100%;
    max-width: 300px;
}

.custom-select-filter {
    appearance: none;
    width: 100%;
    padding: 0.5rem 2.5rem 0.5rem 1rem;
    border: 1px solid #ced4da;
    border-radius: 20px;
    background-color: #fff;
    font-size: 0.9rem;
    color: #495057;
}

.search-icon {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    pointer-events: none;
}

.ticket-action-buttons {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
</style>